import ApiService from "../apiService";
import merge from "lodash/merge";
import axios from "axios";
import { get, postForm, downloadFile } from "../apiService";

export const model = "attachments";

export default class AttachmentService extends ApiService {
  findAll() {
    return get(`/${model}`);
  }

  save(item, model) {
    delete item["attachments"];
    delete item.attributes["fileUrl"];
    return this.baseSave(model, item);
  }

  download(link) {
    return this.downloadFile(link);
  }

  archive(item) {
    return this.baseArchive(model, item);
  }

  importData(file, model) {
    let formData = new FormData();
    formData.append("file", file);
    return postForm(`/${model}/import/csv`, formData);
  }
}



// WEBPACK FOOTER //
// ./src/services/attachmentService/index.js